import React from "react"
import { ArrowSubmitButton, ReimbursementDialogFraming, BackArrow } from "../shared/layouts"
import { Progress } from "#/components/views/modal/Progress"
import { useStateMachine } from "#/components/context/stateMachine/StateMachineV2"
import { useReimbursementContext } from "#/components/context/reimbursement/GetReimbursedContext"
import { FormattedMessage, useIntl } from "react-intl"
import { DialogContentText, DialogTitle, Box } from "@carrotfertility/carotene-core"
import { DialogActionsBar, Form, FormRadioGroup } from "@carrotfertility/carotene-core-x"

export const AttestationCoveredByMedicareAu = (): JSX.Element => {
  const { send, back } = useStateMachine()
  const intl = useIntl()

  const { state, updateAttestationIsCoveredByMedicareAu } = useReimbursementContext()

  const canSubmit = state.attestationIsCoveredByMedicareAu != null

  const handleContinueClick = (): void => {
    if (state.attestationIsCoveredByMedicareAu) {
      send("COVERED_BY_MEDICARE")
      return
    }
    send("")
  }

  const goBack = (): void => {
    updateAttestationIsCoveredByMedicareAu(null)
    back()
  }

  return (
    <>
      <Progress
        numSteps={3}
        step={2}
        label={intl.formatMessage({ defaultMessage: "About This Expense" })}
        inactiveStepBackgroundColor="#DBE6EE"
      />
      <BackArrow onClick={goBack} />
      <ReimbursementDialogFraming>
        <DialogTitle>
          <FormattedMessage defaultMessage="Is any part of this expense covered by Medicare?" />
        </DialogTitle>
        <Box sx={{ display: "flex", flexDirection: "column", gap: (theme) => theme.tokens.spacing.lg }}>
          <DialogContentText>
            <FormattedMessage defaultMessage="We need this information to process your expense accurately." />
          </DialogContentText>
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              alignItems: { xs: "flex-start", md: "center" }
            }}
          >
            <Form onSubmit={() => null}>
              <FormRadioGroup
                aria-labelledby="step-heading"
                name="attestationIsCoveredByMedicareAu"
                controllerProps={{ rules: { required: intl.formatMessage({ defaultMessage: "Required" }) } }}
                options={[
                  { label: intl.formatMessage({ defaultMessage: "Yes" }), value: "true" },
                  { label: intl.formatMessage({ defaultMessage: "No" }), value: "false" }
                ]}
                onChange={(e) => {
                  updateAttestationIsCoveredByMedicareAu((e.target as HTMLInputElement).value === "true")
                }}
              />
            </Form>
          </Box>
        </Box>
      </ReimbursementDialogFraming>
      <DialogActionsBar
        primaryAction={
          <ArrowSubmitButton enabled={canSubmit} onClick={handleContinueClick}>
            <FormattedMessage defaultMessage="Continue" />
          </ArrowSubmitButton>
        }
      />
    </>
  )
}
